import { Spinner } from "@nextui-org/react";
import React, { useEffect, useState } from "react";
import Layout from "../../components/Layout";

const MerchPage = () => {
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  }, []);
  return (
    <div>
      {!isLoading ? (
        <iframe
          src="https://cook-e-store.printify.me/"
          title="Cook-E Store"
          className="w-full h-screen border-none"
          loading="eager"
        />
      ) : (
        <Layout>
          <Spinner size={60} />
        </Layout>
      )}
    </div>
  );
};

export default MerchPage;
